import { render, staticRenderFns } from "./FbxViewer.vue?vue&type=template&id=62664300&"
import script from "./FbxViewer.vue?vue&type=script&lang=js&"
export * from "./FbxViewer.vue?vue&type=script&lang=js&"
import style0 from "./FbxViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports